import React from "react";
import { cn } from "../utils/utils";
import Loader from "./../shared/Loader";

const CustomButton = (props) => {
  const { children, className, onClick, disabled, tab, isLoading, type } =
    props;

  return (
    <button
      type={type}
      tabIndex={tab}
      onClick={onClick}
      disabled={disabled}
      className={cn("  ", className)}
    >
      {isLoading ? (
        <div className="w-8 h-8">
          <Loader />
        </div>
      ) : (
        children
      )}
    </button>
  );
};

export default CustomButton;
